import {call, put, takeLatest} from "redux-saga/effects";
import {getDashboardData} from "../AsyncActions/dashboard.async";
import * as actions from "../action.constants";

function* dashboardRequest() {
  try {
    const response = yield call(getDashboardData);
    if (response) {
      yield put({
        type: actions.SAVE_CARD_DATA,
        responsePayload: response?.data,
      });
    }
  } catch (e) {
    // console.log("error", e);
  }
}

export function* dashboardSaga() {
  yield takeLatest(actions.REQUEST_CARD_DATA, dashboardRequest);
}
